export default function LogoMRG({ dark = false }) {
  const ink = dark ? '#FFFFFF' : '#1C2B3A';
  const acc = '#D4600A';

  return (
    <svg
      viewBox="0 0 180 48"
      height="42"
      style={{ display: 'block' }}
      aria-label="Mantenimiento M&RG"
    >
      {/* Pistola estilizada */}
      <g fill={ink} opacity="0.9">
        <rect x="2"  y="16" width="14" height="9"  rx="2" />
        <rect x="14" y="12" width="22" height="5"  rx="1.5" />
        <rect x="14" y="25" width="8"  height="10" rx="2" />
        <rect x="34" y="13" width="4"  height="3"  rx="1" />
      </g>
      {/* M & RG en estilo script bold */}
      <text x="46" y="34" fontFamily="Georgia, 'Times New Roman', serif" fontSize="28" fontWeight="700" fontStyle="italic" fill={ink} letterSpacing="-1">M</text>
      <text x="72" y="30" fontFamily="Georgia, serif" fontSize="18" fontWeight="400" fill={acc} letterSpacing="1">&amp;</text>
      <text x="88" y="34" fontFamily="Georgia, 'Times New Roman', serif" fontSize="28" fontWeight="700" fontStyle="italic" fill={ink} letterSpacing="-1">RG</text>
      {/* Línea base */}
      <path d="M46 38 Q112 42 148 38" stroke={ink} strokeWidth="1.5" fill="none" opacity="0.4" />
    </svg>
  );
}
